import { useRef } from "react";

/**
 * Returns a frozen snapshot of `value` that only updates when `resetKey`
 * changes identity. Useful for capturing server-fetched state at mount so
 * that cache-update side effects (e.g. PUT 200 setting new query data) don't
 * re-apply the value during a session.
 */
export const useFrozenOnKey = <T>(value: T, resetKey: unknown): T => {
  const frozenRef = useRef(value);
  const keyRef = useRef(resetKey);
  if (keyRef.current !== resetKey) {
    keyRef.current = resetKey;
    frozenRef.current = value;
  }
  return frozenRef.current;
};
